(function(){
  var root = document.getElementById('gsms-home');
  if (!root) return;

  /* Åpent nå – norsk tid */
  try {
    var parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Oslo',weekday:'short',hour:'2-digit',minute:'2-digit',hour12:false}).formatToParts(new Date());
    var get = function(t){ for (var i=0;i<parts.length;i++){ if(parts[i].type===t) return parts[i].value; } return ''; };
    var day = get('weekday'), h = parseInt(get('hour'),10), m = parseInt(get('minute'),10), now = h*60+m;
    var open = null, close = null;
    if (['Mon','Tue','Wed','Thu','Fri'].indexOf(day) > -1){ open = 540; close = 1200; }
    else if (day === 'Sat'){ open = 540; close = 1080; }
    var txt = root.querySelector('[data-open-text]'), dot = root.querySelector('[data-open-dot]');
    if (open !== null && now >= open && now < close){ txt.textContent = 'Åpent nå · til ' + (close/60) + ':00'; }
  else { dot.classList.add('is-closed'); txt.textContent = (open !== null && now < open) ? 'Åpner kl. 09:00' : 'Stengt nå · Man–fre 9–20, lør 9–18'; }
  } catch(e){}

  /* Prisfinner */
  var brandsEl = root.querySelectorAll('[data-brand]');
  var modelEl = document.getElementById('gh-model');
  var repairsEl = document.getElementById('gh-repairs');
  var resultEl = document.getElementById('gh-result');
  var qEl = document.getElementById('gh-q');
  var listEl = document.getElementById('gh-results');
  var products = null, loading = null, current = { brand:null, product:null, variant:null };

  var order = ['skjerm','batteri','ladeport','bakdeksel','bakglass','bak kamera','front kamera','kameralinse','vannskade'];
  function rank(t){ t = t.toLowerCase(); for (var k=0;k<order.length;k++){ if (t.indexOf(order[k]) > -1) return k; } return 99; }

  function brandOf(t){
    var s = t.toLowerCase();
    if (s.indexOf('ipad') > -1) return 'ipad';
    if (s.indexOf('iphone') > -1) return 'iphone';
    if (s.indexOf('samsung') > -1 || s.indexOf('galaxy') > -1) return 'samsung';
    return 'andre';
  }
  function nameOf(t){ return t.replace(/^Reparasjon av\s+/i,'').replace(/^Samsung\s+/i,'').trim(); }

  /* Nyeste modeller først */
  function numOf(n){
    var y = n.match(/\((\d{4})\)/);
    if (/ipad/i.test(n) && y) return parseInt(y[1],10);
    if (/^iPhone SE/i.test(n)) return 8.5;
    if (/^iPhone X/i.test(n)) return 10;
    var d = n.match(/\d+/);
    return d ? parseInt(d[0],10) : 0;
  }
  function seriesOf(n){
    var s = n.replace(/^Galaxy\s+/i,'');
    if (!/^Galaxy/i.test(n)) return 0;
    if (/^S\d/i.test(s)) return 0;
    if (/^Z/i.test(s)) return 1;
    if (/^Note/i.test(s)) return 2;
    if (/^A\d/i.test(s)) return 3;
    return 4;
  }
  function byNewest(a,b){
    return (seriesOf(a.name) - seriesOf(b.name)) || (numOf(b.name) - numOf(a.name)) || b.name.localeCompare(a.name,'nb',{numeric:true});
  }

  function kr(p){ var n = Math.round(parseFloat(p)); return n.toLocaleString('nb-NO').replace(/[  ]/g,' ') + ' kr'; }
  /* Viser førpris overstreket når varianten har sammenligningspris */
  function priceHtml(v){ var c = parseFloat(v.cmp); return (c && c > parseFloat(v.price)) ? '<s style="opacity:.6;font-weight:400;margin-right:6px">' + kr(v.cmp) + '</s>' + kr(v.price) : kr(v.price); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function load(){
    if (products) return Promise.resolve(products);
    if (loading) return loading;
    var all = [];
    function page(n){
      return fetch('/collections/reparasjon/products.json?limit=250&page=' + n)
        .then(function(r){ return r.json(); })
        .then(function(d){
          var list = (d && d.products) || [];
          all = all.concat(list);
          return (list.length === 250 && n < 5) ? page(n+1) : all;
        });
    }
    loading = page(1).then(function(list){
      products = list.filter(function(p){ return p.variants && p.variants.length; }).map(function(p){
        var vs = p.variants.map(function(v){ return { id:v.id, title:v.title, price:v.price, cmp:v.compare_at_price }; });
        vs.sort(function(a,b){ return rank(a.title) - rank(b.title); });
        return { title:p.title, name:nameOf(p.title), handle:p.handle, brand:brandOf(p.title), variants:vs };
      }).sort(byNewest);
      return products;
    }).catch(function(){ products = []; return products; });
    return loading;
  }

  function setBrand(b){
    current.brand = b; current.product = null; current.variant = null;
    brandsEl.forEach(function(el){ el.setAttribute('aria-pressed', el.getAttribute('data-brand') === b ? 'true' : 'false'); });
    modelEl.disabled = true;
    modelEl.innerHTML = '<option value="">Laster modeller…</option>';
    repairsEl.innerHTML = '<p class="gh-hint">Velg modell for å se prisene.</p>';
    resultEl.hidden = true;
    return load().then(function(list){
      var mine = list.filter(function(p){ return p.brand === b; });
      if (!mine.length){ modelEl.innerHTML = '<option value="">Ingen modeller funnet</option>'; return; }
      modelEl.innerHTML = '<option value="">Velg modell (' + mine.length + ')</option>' +
        mine.map(function(p){ return '<option value="' + esc(p.handle) + '">' + esc(p.name) + '</option>'; }).join('');
      modelEl.disabled = false;
    });
  }

  function setProduct(handle){
    var p = (products || []).filter(function(x){ return x.handle === handle; })[0];
    current.product = p || null; current.variant = null; resultEl.hidden = true;
    if (!p){ repairsEl.innerHTML = '<p class="gh-hint">Velg modell for å se prisene.</p>'; return; }
    repairsEl.innerHTML = p.variants.map(function(v, i){
      return '<button type="button" class="gh-rep" aria-pressed="false" data-i="' + i + '"><b>' + esc(v.title) + '</b><span>' + priceHtml(v) + '</span></button>';
    }).join('');
  }

  function setVariant(i){
    var p = current.product; if (!p) return;
    var v = p.variants[i]; current.variant = v;
    repairsEl.querySelectorAll('.gh-rep').forEach(function(el){ el.setAttribute('aria-pressed', el.getAttribute('data-i') === String(i) ? 'true' : 'false'); });
    document.getElementById('gh-r-what').textContent = v.title + ' · ' + p.name;
    document.getElementById('gh-r-price').innerHTML = priceHtml(v);
    document.getElementById('gh-r-link').href = '/products/' + p.handle + '?variant=' + v.id;
    resultEl.hidden = false;
    if (window.innerWidth < 990) resultEl.scrollIntoView({ behavior:'smooth', block:'center' });
  }

  brandsEl.forEach(function(el){ el.addEventListener('click', function(){ setBrand(el.getAttribute('data-brand')); }); });
  modelEl.addEventListener('change', function(){ setProduct(modelEl.value); });
  repairsEl.addEventListener('click', function(e){ var b = e.target.closest('.gh-rep'); if (b) setVariant(parseInt(b.getAttribute('data-i'),10)); });

  /* Søk */
  qEl.addEventListener('focus', load, { once:true });
  qEl.addEventListener('input', function(){
    var q = qEl.value.trim().toLowerCase().replace(/\s+/g,' ');
    if (q.length < 2){ listEl.hidden = true; listEl.innerHTML = ''; return; }
    load().then(function(list){
      var words = q.split(' ');
      var hits = list.filter(function(p){ var t = (p.title + ' ' + p.name).toLowerCase(); return words.every(function(w){ return t.indexOf(w) > -1; }); }).slice(0, 8);
      listEl.innerHTML = hits.length ? hits.map(function(p){ return '<li><button type="button" data-h="' + esc(p.handle) + '" data-b="' + p.brand + '">' + esc(p.name) + '</button></li>'; }).join('')
        : '<li><button type="button" disabled>Fant ingen modell – ring oss på 458 93 090</button></li>';
      listEl.hidden = false;
    });
  });
  listEl.addEventListener('click', function(e){
    var b = e.target.closest('button[data-h]'); if (!b) return;
    var h = b.getAttribute('data-h');
    listEl.hidden = true; qEl.value = b.textContent;
    setBrand(b.getAttribute('data-b')).then(function(){ modelEl.value = h; setProduct(h); repairsEl.scrollIntoView({ behavior:'smooth', block:'center' }); });
  });

  /* Sticky knapper på mobil – vises når prisfinneren er ute av syne */
  var sticky = document.getElementById('gh-sticky'), finder = document.getElementById('gh-finder');
  if ('IntersectionObserver' in window){
    new IntersectionObserver(function(en){ sticky.classList.toggle('is-on', !en[0].isIntersecting); }).observe(finder);
  } else { sticky.classList.add('is-on'); }
})();